export default __webpack_public_path__ + "static/media/fridge2-beforeA-1920w.9411420c.avif";